import { APIGet, APIPut, IAPIResponse } from "api/protocols";
import { CancelToken } from "axios";
import { ILeague } from "redux/reducers/models/league";

const apiVersion = "2024-04";
const baseCustomerUrl = "/" + apiVersion + "/customer/league";

interface IGetLeague {
  facility_id?: number;
  handle?: string;
  year?: number;
  month?: number;
  timeframe?: "upcoming" | "past";
  offset?: number;
  limit?: number;
  search?: string;
  user_id?: number;
  client_id?: number;
  extended?: boolean;
}

interface IPutLeagueParticipant {
  //single participant
  id?: number;
  display_name_on_tee_sheet?: number;
  //multiple participants (for the same user)
  participants?: Array<{
    id: number;
    display_name_on_tee_sheet: number;
  }>;
}

//GET Customer bookings
export async function GetLeagueParticipants(params: { league_id: number }, useGlobalLoader: boolean) {
  return await APIGet(baseCustomerUrl + "/participant", params, useGlobalLoader);
}

export async function PutLeagueParticipant(params: IPutLeagueParticipant, useGlobalLoader: boolean) {
  return await APIPut(baseCustomerUrl + "/participant", params, useGlobalLoader);
}

export async function GetCustomerLeague(
  params: IGetLeague,
  useGlobalLoader: boolean,
  token?: CancelToken,
): Promise<IAPIResponse<Array<ILeague>>> {
  return await APIGet(baseCustomerUrl, params, useGlobalLoader, token);
}
